module.exports = __webpack_public_path__ + "img/tech_image_11.9e19556b.jpg";